module.exports = __webpack_public_path__ + "static/media/stteresa.a202abd4.webp";